<template>
<el-dialog class="editDialog" title="验收" :visible.sync="visible" :destroy-on-close="true" :close-on-click-modal="false" @close="cancel">
  <template v-if="visible">
    <section>
      <el-form ref="form1" :model="form1" :rules="rule">
        <el-form-item label="验收结果：" prop="remark">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form1.remark" maxlength="150">
          </el-input>
        </el-form-item>

        <el-form-item label="上传图片：" prop="pics">
          <el-upload-secondary  list-type="picture-card" v-model="fileList" accepts="jpg,png">
          </el-upload-secondary>
          <el-dialog :visible.sync="dialogVisible">
            <img v-default-img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>

      </el-form>
    </section>

    <div slot="footer" class="dialog-footer">
      <el-button class="cancelButton" type="primary" @click="cancel">取消</el-button>
      <el-button class="confirmButton" type="primary" @click="submit">保存</el-button>
    </div>
  </template>
</el-dialog>
</template>

<script>
import {
  descriptor
} from "utils"
export default {
  props: {
    row: {

    },
    pVisible: {
      type: Boolean
    }
  },
  data() {
    return {
      form1: {
        opt: 7,
      },
      visible: false,
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: []
    }
  },
  computed: {
    rule() {
      let that = this;
      return {
        remark: descriptor(new Map([
          [true, "请填写验收结果"]
        ]), "blur")
      }
    },
    urls() {
      return this.fileList.map(o => `${process.env.fileUrl}/${o.response.data[0]}`).join(';')
    }
  },
  methods: {
    resetForm() {
      this.form1 = {
        opt: 7,
      };
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    submit() {
      this.$refs['form1'].validate(valid => {
        if (valid) {
          this.$axiospost('/operation/risk_flow/new', {
            ...this.form1,
            pic: this.urls,
            flowId: this.row.flowId
          }).then(res => {
            this.$message({
              showClose: true,
              message: '处理成功',
              type: 'success'
            });
            this.$emit('cancel');
          })
        }
      })
    },
    cancel() {
      this.$emit('cancel');
    }
  },
  mounted() {},
  watch: {
    pVisible(n) {
      this.visible = n;
      if (n) {
        this.resetForm();
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/yinhuan/mine/more/yanshou.vue